module.exports = __webpack_public_path__ + "img/ditan.e182a944.jpg";